import "react-toastify/dist/ReactToastify.min.css";
import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { ToastContainer } from "react-toastify";
import Menu from "./Components/Menu/Menu";
import Loading from "./Components/Loading/Loading";
import configureStore from "./Redux/store";
import Routes from "./Routes";

class App extends Component {
  componentDidMount() {
    switch (window.location.host) {
      case "casa-cedule.herokuapp.com":
        document.title = "CASA Chantiers";
        break;
      case "casa-tech-cedule.herokuapp.com":
        document.title = "CASA Techs";
        break;
    }
  }

  render() {
    return (
      <Provider store={configureStore()}>
        <MuiThemeProvider>
          <BrowserRouter>
            <Menu />
            <Loading />
            <Routes />
          </BrowserRouter>
        </MuiThemeProvider>
        <ToastContainer />
      </Provider>
    );
  }
}

App.whyDidYouRender = true;

export default App;
